import { render, staticRenderFns } from "./Consents.vue?vue&type=template&id=baadb5b2&scoped=true&"
import script from "./Consents.vue?vue&type=script&lang=js&"
export * from "./Consents.vue?vue&type=script&lang=js&"
import style0 from "./Consents.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Consents.vue?vue&type=style&index=1&id=baadb5b2&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baadb5b2",
  null
  
)

export default component.exports